import React, { useEffect, useMemo, useState } from 'react';
import { matchPath } from 'react-router-dom';
import RingCustomizerContainer from '..';
import { AnyObject, urlToParams } from '../../utils/basic';
import NoMatch from '../NoMatch/NoMatch';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import Homepage from '../Homepage';

interface IProps {
  match: any;
  location: any;
  history: any;
}

interface IState {
  type: number;
  ring_url: string;
}

function matchesPath(pathname: string, patterns: readonly string[]) {
  const pathOnly = pathname.split('?')[0];
  return patterns.some((pattern) => matchPath({ path: pattern, end: true }, pathOnly));
}

const URLScreening = (props: IProps) => {
  const { product } = useAppSelector((state: RootState) => ({ ...state.customizer }));

  const [isLandingPage, setIsLandingPage] = useState(false);
  const [state, setState] = useState<IState>({
    type: 1,
    ring_url: ''
  });

  // Derived during render instead of in the effect below, so it can never lag a
  // commit behind `props.location`. The customizer rebuilds its params from this
  // prop on every location change, and a stale value here would revert params
  // such as `bestSeller` immediately after a navigation.
  const otherQueryParams: AnyObject = useMemo(() => {
    const searchParams = new URLSearchParams(props.location.search);
    const { ring_url, landing_page, ...rest } = Object.fromEntries(searchParams.entries());
    return rest;
  }, [props.location.search]);

  useEffect(() => {
    const searchParams = new URLSearchParams(props.location.search);
    const { ring_url, landing_page } = Object.fromEntries(searchParams.entries());
    if (ring_url) {
      const isRingType1 = matchesPath(ring_url, [
        '/rings/profiles/:profile/widths/:width/ring_materials/:ring_materials',
        '/:pathPrefix/rings/profiles/:profile/widths/:width/ring_materials/:ring_materials'
      ]);

      const isRingType2 = matchesPath(ring_url, [
        '/women/rings/styles/:styles/ring_materials/:ring_materials/color_arrangements/:color_arrangements/stone_quantities/:stone_quantities/variants/:variants',
        '/:pathPrefix/women/rings/styles/:styles/ring_materials/:ring_materials/color_arrangements/:color_arrangements/stone_quantities/:stone_quantities/variants/:variants'
      ]);

      const isRingType3 = matchesPath(ring_url, [
        '/rings/:ring_type/ring_materials/:ring_materials',
        '/:pathPrefix/rings/:ring_type/ring_materials/:ring_materials'
      ]);

      if (isRingType1) {
        setState({
          type: 1,
          ring_url
        });
      }

      if (isRingType2) {
        setState({
          type: 2,
          ring_url
        });
      }

      if (isRingType3) {
        setState({
          type: 3,
          ring_url
        });
      }
    }
    if (landing_page !== null && landing_page !== undefined) {
      setIsLandingPage(true);
    }
  }, [props.location]);

  useEffect(() => {
    const searchParams = new URLSearchParams(props.location.search);
    const ring_url = searchParams.get('ring_url') || '';

    if (product && !otherQueryParams.base_ring_url) {
      const { pathParams } = urlToParams(ring_url);
      let base_ring_url = product.ring_options_url;
      if (pathParams.pathPrefix) {
        base_ring_url = `/${pathParams.pathPrefix}` + base_ring_url;
      }
      const sep = props.location.search && props.location.search.length > 1 ? '&' : '?';
      const navigate_url = `${props.location.pathname}${props.location.search || ''}${sep}base_ring_url=${encodeURIComponent(base_ring_url)}`; // &redirect_url=${encodeURIComponent(document.referrer || '')}
      props.history.push(navigate_url);
    }
  }, [product]);

  return (
    <>
      {state.ring_url && state.type ? (
        <RingCustomizerContainer {...props} {...state} otherQueryParams={otherQueryParams} />
      ) : isLandingPage ? (
        <Homepage {...props} />
      ) : (
        <NoMatch />
      )}
    </>
  );
};

export default URLScreening;
